"use client";

import { c as _c } from "react/compiler-runtime";
import { Typography } from "@/shared/ui/atoms";
import { SubjectTitle, TreatmentSubjectRatioList } from "@/widgets/hospital/ui/molecules";
import { useQueryHospitalSubjectsAnalysis } from "@/entities/hospital/hooks/queries";
import { useLocale, useTranslations } from "next-intl";
import { useHospitalOriginId } from "@/entities/hospital/model/hospital-origin-id";
import { getHospitalAnalysisDisplayLabel } from "@/entities/hospital/lib/analysis-label-localization";
const TreatmentSubjectAnalysis = t0 => {
  const $ = _c(28);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    primaryTreatment
  } = t1;
  const t = useTranslations();
  const locale = useLocale();
  const hospitalOriginId = useHospitalOriginId();
  const {
    data: subjectsAnalysis
  } = useQueryHospitalSubjectsAnalysis(hospitalOriginId);
  let t2;
  if ($[2] !== primaryTreatment) {
    t2 = primaryTreatment?.trim();
    $[2] = primaryTreatment;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const treatmentName = t2;
  let t3;
  if ($[4] !== subjectsAnalysis) {
    t3 = subjectsAnalysis?.slice(0, 4) || [];
    $[4] = subjectsAnalysis;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const bestTreatmentSubject = t3;
  const t4 = subjectsAnalysis?.[0]?.treatment || "";
  let t5;
  if ($[6] !== locale || $[7] !== t4) {
    t5 = getHospitalAnalysisDisplayLabel(t4, locale);
    $[6] = locale;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const bestTreatmentSubjectLabel = t5;
  let t6;
  if ($[9] !== t) {
    t6 = t("reviewTabContent.tooltipContent");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const tooltipContent = t6;
  if (subjectsAnalysis?.length === 0 || !bestTreatmentSubjectLabel) {
    return null;
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("reviewTabContent.treatmentSubjectAnalysis");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7 || $[14] !== tooltipContent) {
    t8 = <SubjectTitle title={t7} tooltip={true} tooltipContent={tooltipContent} />;
    $[13] = t7;
    $[14] = tooltipContent;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== bestTreatmentSubjectLabel || $[17] !== t || $[18] !== treatmentName) {
    t9 = treatmentName && <Typography size={16} className="text-gray-800 font-medium mx-5 mt-3 mb-[16px] py-2.5 rounded-lg bg-gray-100 text-center"><strong className="text-primary-700 font-semibold">{bestTreatmentSubjectLabel} </strong>{t("reviewTabContent.bestTreatmentSubjectLabelFirst")} {treatmentName}{t("reviewTabContent.bestTreatmentSubjectLabelLast")}</Typography>;
    $[16] = bestTreatmentSubjectLabel;
    $[17] = t;
    $[18] = treatmentName;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== bestTreatmentSubject) {
    t10 = bestTreatmentSubject || [];
    $[20] = bestTreatmentSubject;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10) {
    t11 = <TreatmentSubjectRatioList treatmentSubjectRatioList={t10} />;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t8 || $[26] !== t9) {
    t12 = <div className="pt-[18px]">{t8}{t9}{t11}</div>;
    $[24] = t11;
    $[25] = t8;
    $[26] = t9;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};
export default TreatmentSubjectAnalysis;